module.exports = __webpack_public_path__ + "img/04_bastien-nvs.6e0bd89f.jpg";